export enum ERefsMOB {
	APP_INSTALLED = 'installed',
}
